<div class="qr-wrapper">
  <div class="qr-left">
    <canvas #qrCanvas *ngIf="qrCodeImage"></canvas>
    <img *ngIf="!qrCodeImage" [src]="qrCodeImage" alt="QR Code" />
    <p *ngIf="!qrCodeImage">Generating QR Code...</p>
  </div>
  <div class="qr-right">
    <p class="short-url" *ngIf="shortUrl">
      Short URL:
      <a [href]="shortUrl" target="_blank" (click)="handleShortUrlClick($event)">{{ shortUrl }}</a>
    </p>
     <!-- ✅ Updated QR Status Section -->
     <div class="qr-status">
      <button class="qr-button" (click)="handleFreshClick()">Refresh QR Code</button>      
    </div>
  </div>
</div>
